function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Envelope Closed"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-width": 32,
  "data-height": 22,
  className: "iconic-container iconic-envelope-closed",
  transform: "scale(1 1 ) translate(0 5 ) "
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4 10.8l15.1-7.6c.3-.1.5-.4.5-.7v-2c0-.3-.2-.5-.5-.5h-31c-.3 0-.5.2-.5.5v2c0 .3.2.6.4.7l15.1 7.6c.3.1.7.1.9 0z",
  className: "iconic-envelope-closed-envelope-flap iconic-property-accent iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 13.8l-15.2-7.6c-.2-.1-.4 0-.4.3v15c0 .3.2.5.5.5h31c.3 0 .5-.2.5-.5v-15c0-.3-.2-.4-.4-.3l-15.1 7.6c-.3.1-.7.1-.9 0z",
  className: "iconic-envelope-closed-envelope-body iconic-property-fill"
}));

function SvgEnvelopeClosedMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon": "envelope-closed",
    width: 32,
    height: 32,
    className: "iconic iconic-envelope iconic-size-md iconic-envelope-closed",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeClosedMd);
export default __webpack_public_path__ + "static/media/envelope-closed-md.2ecfdf26.svg";
export { ForwardRef as ReactComponent };